document.addEventListener("click", (event: MouseEvent) => {
  if (event.target instanceof HTMLElement) {
    const isPaginationItem = event.target.closest(".pagination__item");

    if (isPaginationItem) {
      const productGridContainer = document.querySelector(
        ".product-grid-container",
      );

      if (productGridContainer) {
        const header = document.querySelector("header");
        const headerHeight = header ? header.offsetHeight : 0;

        const elementPosition =
          productGridContainer.getBoundingClientRect().top +
          window.pageYOffset -
          headerHeight -
          40;

        window.scrollTo({ top: elementPosition, behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  }
});
